import React from "react";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import JsonView from 'react18-json-view'
import 'react18-json-view/src/style.css'

export default function ActionLogOutputInfo(props) {

    const { historyLog } = props;

    const actionInfo = { ...historyLog.details };

    return (
        <Card>
            <CardHeader color="warning">
                <h4>Izlazni podatci</h4>
            </CardHeader>
            <CardBody sx={{ height: "470px" }}>
                <JsonView src={actionInfo} />
            </CardBody>
        </Card>
    );
}